import React from 'react'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell, MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useProjectListContext } from './Context'

export const ListHeader = (props: HeaderRowConfig) => {
  const listContext = useProjectListContext()
  const { toggleSelectAll, hasSelectedAll } = listContext.projectListWithSelection
  return (
    <>
      <MenuHeaderCell />

      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />

      {props._renderDataHeaderCell()}
    </>
  )
}
